<template>
  <div class="container" v-bind:class="{ flipped: isFlipped }">
    <div class="tile back">
      <div class="upper card">
        <div class="digit">
          {{current}}
        </div>
      </div>
      <div class="lower card">
        <div class="digit">
          {{previous}}
        </div>
      </div>
    </div>

    <div class="tile front">
      <div class="upper card">
        <div class="digit">
          {{previous}}
        </div>
      </div>
      <div class="lower card">
        <div class="digit">
          {{current}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function() {
      return {
        isFlipped: false,
        previous: ' ',
        current: ' ',
        target: ' ',
        cards: ' 0123456789'
      }
    },
    methods: {
      set: function(n) {
        this.isFlipped = false;
        this.previous = this.current;
        this.current = n;

        const self = this;
        setTimeout(function() {
          self.isFlipped = true;
        }, 50);
      },
      update: function() {
        // character not in set
        if(this.cards.indexOf(this.target) < 0) {
          this.set(this.target);
          return;
        }

        var i = this.cards.indexOf(this.current);

        // calculate next position (up or down depending on direcion)
        i = (i + this.cards.length + this.direction)%this.cards.length;

        this.set(this.cards.charAt(i));
        if(this.current != this.target) {
          var self = this;
          setTimeout(function() {
            self.update();
          }, 400);
        }
      }
    },
    props: {
      value: String,
      loop: Boolean,
      delay: Number,
      direction: {
        type: Number,
        default: 1
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function(v) {
          var self = this;
          setTimeout(function() {
            if(self.current != v) {
              if(self.loop && document.hasFocus()) {
                self.target = v.toUpperCase();
                self.update();
              }
              else {
                self.set(v.toUpperCase());
              }
            }
          }, this.delay);
        }
      }
    }
  }
</script>

<style scoped>
  .container {
    font-size: 1em;
    height: 1.1em;
    width: 0.85em;

    display: inline-block;
  }

  .tile {
    position: absolute;

    transform-style: preserve-3d;
  }

  .front {
    z-index: 10;
  }

  .card {
    font-family: 'Open Sans' sans-serif;

    background: linear-gradient(#1a1a1a, #222);
    border: 1px solid #333;
    border-radius: 0.03em;

    width: 0.8em;
    height: 0.6em;

    overflow: hidden;
    text-align: center;
  }

  .digit {
    font-size: 0.8em;
  }

  .upper {
    margin-bottom: 0.005em;
  }

  .upper .digit {
    transform: translateY(0.05em);
  }

  .lower .digit {
    transform: translateY(-0.72em);
  }

  /* upper flip */
  .front .upper {
    transform-origin: bottom;
    transform: rotateX(0deg);
  }

  .flipped .front .upper {
    transition: transform;
    transition-duration: 0.3s;

    transform-origin: bottom;
    transform: rotateX(-90deg);
  }

  /* lower flip */
  .front .lower {
    transform-origin: top;
    transform: rotateX(90deg);
  }

  .flipped .front .lower {
    transition: transform;
    transition-duration: 0.2s;
    transition-delay: 0.25s;

    transform-origin: top;
    transform: rotateX(0deg);
  }
</style>
